// export const SERVER_URL = "http://localhost:8000";
// export const SERVER_URL = "https://34.214.160.243:8000";
// export const SERVER_URL = "https://api.learnapp.me";
// export const SERVER_URL = "http://95.216.136.56:8000";
// export const SERVER_URL = "http://192.168.0.5:8000";
export const SERVER_URL = "https://api.learnypie.com";
export const imgSrv = SERVER_URL + "/img/";
